import React, { ReactElement } from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import ServerOsOvhBox from "./ServerOsOvhBox";

const OvhOsSection = ({
 selectedOs,
 osList,
 selectOs
}: {
 selectedOs: string;
 osList: Array<string>;
 selectOs: (value: string) => void;
}): ReactElement => {
 return (
  <Stack spacing={2}>
   {osList.find((element) => element.includes("Debian")) && (
    <Stack>
     <Typography fontSize={14} textAlign="left" variant="unboundedTitle">
      Debian
     </Typography>
     <ServerOsOvhBox
      selectedOs={selectedOs}
      osList={osList.filter((element) => element.includes("Debian") && !element.includes("-"))}
      selectOs={(value: string) => {
       selectOs(value || "");
      }}
     />
    </Stack>
   )}
   {osList.find((element) => element.includes("Ubuntu")) && (
    <Stack>
     <Typography textAlign="left" variant="unboundedTitle" fontSize={14}>
      Ubuntu
     </Typography>
     <ServerOsOvhBox
      selectedOs={selectedOs}
      osList={osList.filter((element) => element.includes("Ubuntu"))}
      selectOs={(value: string) => {
       selectOs(value || "");
      }}
     />
    </Stack>
   )}
   {osList.find((element) => element.includes("Windows")) && (
    <Stack>
     <Typography textAlign="left" variant="unboundedTitle" fontSize={14}>
      Windows
     </Typography>
     <ServerOsOvhBox
      selectedOs={selectedOs}
      osList={osList.filter((element) => element.includes("Windows"))}
      selectOs={(value: string) => {
       selectOs(value || "");
      }}
     />
    </Stack>
   )}
  </Stack>
 );
};

export default OvhOsSection;
